import {i18n} from '@netx/core/i18n';

const EMAIL_REGEX =
	// eslint-disable-next-line security/detect-unsafe-regex
	/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const validateEmail = (value: any) => {
	return value != null && EMAIL_REGEX.test(value.toString())
		? true
		: i18n.t('i18n.invalidValue');
};

export default validateEmail;
